import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.ClearField = class ClearField extends Snappy.BaseComponent {
    static get tagName() {
        return 'cfa-clear-field';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();

        if (!this.input.length || !this.button.length) {
            return;
        }

        this.setEventListeners();
        this.checkInput();
    }

    setVars() {
        this.input = this.$element.find('.js-clear-input');
        this.button = this.$element.find('.js-clear-button');
    }

    setEventListeners() {
        this.button.on('click', this.onClick.bind(this));
        this.input.on('keyup blur', this.checkInput.bind(this));
    }

    onClick(e) {
        e.preventDefault();
        this.input.val('').focus();
        this.toggleClass(false);
    }

    checkInput(e) {
        if (this.input.val().length === 0) {
            this.toggleClass(false);
        } else {
            this.toggleClass(true);
        }
    }

    toggleClass(bool) {
        this.button.toggleClass('is-visible', bool)
    }
};



// WEBPACK FOOTER //
// ./components/cfa-search-results/scripts/cfa-clear-field.js